import React, { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Mail, Loader2 } from "lucide-react";
import { Button } from "./components/ui/button";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "./components/ui/alert-dialog";

export const ResendRenewedCardsButton = () => {
  const [open, setOpen] = useState(false);
  const [preview, setPreview] = useState(null);
  const [sending, setSending] = useState(false);

  const openDialog = async () => {
    setPreview(null);
    setOpen(true);
    try {
      const { data } = await axios.get("admin/membership-cards/renewed/preview");
      setPreview(data);
    } catch (e) {
      toast.error(e.response?.data?.detail || "Could not load renewed members");
      setOpen(false);
    }
  };

  const send = async () => {
    setSending(true);
    try {
      const { data } = await axios.post("admin/membership-cards/renewed/resend");
      toast.success(`Sending ${data.queued} membership card(s) for ${data.year}. This may take a few minutes.`);
      setOpen(false);
    } catch (e) {
      toast.error(e.response?.data?.detail || "Could not send the cards");
    } finally {
      setSending(false);
    }
  };

  const canSend = preview && preview.count > 0 && !preview.in_progress;

  return (
    <>
      <Button size="sm" variant="outline" onClick={openDialog} className="text-xs" data-testid="resend-renewed-cards-btn">
        <Mail className="h-3 w-3 mr-1" />
        Resend renewed cards
      </Button>
      <AlertDialog open={open} onOpenChange={setOpen}>
        <AlertDialogContent data-testid="resend-renewed-cards-dialog">
          <AlertDialogHeader>
            <AlertDialogTitle>Resend membership cards</AlertDialogTitle>
            <AlertDialogDescription asChild>
              <div data-testid="resend-renewed-cards-summary">
                {!preview && "Loading…"}
                {preview && !preview.year && "No members have renewed yet."}
                {preview && preview.year && (
                  <>
                    <strong>{preview.count}</strong> member(s) who renewed for <strong>{preview.year}</strong> will
                    receive their updated membership card by email.
                    {preview.in_progress && <div className="mt-2 text-amber-700">A send is already in progress.</div>}
                  </>
                )}
              </div>
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel data-testid="resend-renewed-cards-cancel">Cancel</AlertDialogCancel>
            <AlertDialogAction
              onClick={(e) => { e.preventDefault(); send(); }}
              disabled={!canSend || sending}
              data-testid="resend-renewed-cards-confirm"
            >
              {sending && <Loader2 className="h-3 w-3 mr-1 animate-spin" />}
              Send {preview?.count || ""} card(s)
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
};
